<div class="dialog dialog-error not-a-member">
  <h1 i18n mat-dialog-title>
    We're Sorry!
  </h1>

  <div id="dialog-content" mat-dialog-content>
    <p i18n class="font-size-large">
      An error occurred while trying to retrieve your member information. Please call AAA for additional assistance:
    </p>
  </div>

  <div class="not-a-member_secondary-content">
    <app-call-aaa-button
      i18n-aria-label
      [clickEventPage]="pageType"
      (buttonClick)="onCallAAAClick()"
      aria-label="Contact us">
    </app-call-aaa-button>
  </div>
  <button i18n-aria-label mat-dialog-close class="mat-dialog-close" aria-label="dismiss this message">
    <icon-close></icon-close>
  </button>
</div>
